import { AsyncPipe, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { Observable } from 'rxjs';

import { BasketPreviewComponent } from '../basket-preview/basket-preview.component';
import { ConfigRepository } from '../../../../shared/repositories/config.repository';
import { RestInfoComponent } from './rest-info/rest-info.component';
import { AccountPreviewComponent } from '../account-preview/account-preview.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { BreakpointService } from '../../../../shared/services/breakpoint.service';
import { MobileMenuComponent } from '../mobile-menu/mobile-menu.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  imports: [
    NgIf,
    RouterLink,
    AsyncPipe,
    NgOptimizedImage,
    RestInfoComponent,
    BasketPreviewComponent,
    AccountPreviewComponent,
    HeaderNavComponent,
    MobileMenuComponent,
  ]
})
export class HeaderComponent implements OnInit {
  constructor(
    private router: Router,
    private configRepository: ConfigRepository,
    public breakPoint: BreakpointService,
  ) {}

  logoUrl$: Observable<string | undefined | null> = this.configRepository.logoUrl$;
  phone$: Observable<string | null> = this.configRepository.phone$;
  isBasketMode$: Observable<boolean> = this.configRepository.isBasketMode$;
  isLoyalty$: Observable<boolean> = this.configRepository.isLoyalty$;
  isIiko$: Observable<boolean | null> = this.configRepository.isIiko$;

  isOrderingPage: boolean = false;

  ngOnInit(): void {
    this.subscribeToRouter();

    if (this.router.url.includes('/order-status') && this.breakPoint.isMobile) {
      this.isOrderingPage = true;
    }
  }

  private subscribeToRouter(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isOrderingPage = event.url.includes('/order-status') && this.breakPoint.isMobile;
      }
    });
  }
}
